import { WebStorageStateStore } from "oidc-client-ts";
import { appConfig } from "shared/app-config";

const AuthServiceConstants = Object.freeze({
  clientScope: "openid email profile",
  responseCode: "code",
});

export const oidcConfig = {
    authority: appConfig.SSO_AUTHORITY,
    client_id: appConfig.SSO_CLIENT_ID,
    redirect_uri: `${window.origin}/callback`,
    post_logout_redirect_uri: window.origin,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: false,
    scope: AuthServiceConstants.clientScope,
    response_type: AuthServiceConstants.responseCode,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    staleStateAge: 60,
    revokeTokensOnSignout: true,
};
